import PropTypes from 'prop-types';
import { Summary } from '@eti/types';
import { SECOND_BAGGAGE_PER_TRAVELER } from '@eti/products';
import ProductItem from './ProductItem';

const ProductsList = ({ products = [], checkedBaggageSummary, includedCheckedBaggage }) => {
  const { baggageDetails, baggageStatus } = checkedBaggageSummary || {};
  const secondBaggageDetails = products?.find(
    (product) => product.id === String(SECOND_BAGGAGE_PER_TRAVELER.id),
  );

  // TODO: AN-2781 & AN-2782 once baggageSummary support all other baggage types we can then remove products here. and use baggageSummary instead.
  return products.length > 0 ? (
    products.map((product) => {
      if (product.id === String(SECOND_BAGGAGE_PER_TRAVELER.id) && !includedCheckedBaggage) {
        return null;
      }
      return (
        <ProductItem
          baggageDetails={baggageDetails}
          baggageStatus={baggageStatus}
          key={product.id}
          product={product}
          secondBaggageDetails={secondBaggageDetails}
        />
      );
    })
  ) : (
    <ProductItem baggageDetails={baggageDetails} baggageStatus={baggageStatus} />
  );
};

ProductsList.propTypes = {
  checkedBaggageSummary: Summary,
  includedCheckedBaggage: PropTypes.shape({
    pieces: PropTypes.any,
    weight: PropTypes.number,
    weightUnit: PropTypes.string,
  }),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      quantity: PropTypes.number,
    }),
  ),
};

export default ProductsList;
